import Axios from 'axios';

let https = {};
https.install = function (Vue) {
    let axios = Axios.create({
        // baseURL: 'https://www.sxwts.com.cn/cs/public/api/'
        baseURL: 'https://api.yunqiaokefu.net/api/'

    })
    axios.interceptors.request.use(function (conf) {
        return conf;
    })
    Vue.prototype.$https = axios
}

export default https;



// WEBPACK FOOTER //
// ./src/assets/js/axios.js